import { useState } from 'react';
import { Link } from '@optimus-web/core';
import { WithBillId } from '@mews-commander/types';
import { BillDetailSidePanel } from '../../../../billDetail/components/BillDetailSidePanel';

export interface CorrectionBillLinkProps extends WithBillId {
    label: string;
}

export const CorrectionBillLink = ({ billId, label }: CorrectionBillLinkProps) => {
    const [isDialogOpen, toggleDialog] = useState(false);

    const openModal = () => toggleDialog(true);

    return (
        <>
            <Link as="button" variant="basic" onClick={openModal} standalone>
                {label}
            </Link>
            <BillDetailSidePanel billId={billId} opened={isDialogOpen} closeDialog={() => toggleDialog(false)} />
        </>
    );
};
